import {Card, CardActionArea, Stack, Typography, useTheme} from '@mui/material';
import React, {Fragment} from 'react';

import {makeGetDebtSettlementStatementUrl} from 'main/factories/usecases';
import {Loading} from 'presentation/components/Loading/Loading';
import {ModalError} from 'presentation/components/ModalError';
import {useGetEndpointUrl} from 'presentation/hooks';
import Icon from 'presentation/icons';
import {useExternalServiceStore} from 'presentation/pages/private/store/externalSerivceUrlStore';
import {translations} from 'presentation/translations-new';

const {debtSettlementStatement} = translations['pt-br'].privateFlow.services;
const {title, subtitle, description, tryAgainBtn, backAction} =
	translations['pt-br'].others.genericErrorModal;

export function DebtSettlementStatement() {
	const cachedURL = useExternalServiceStore(state => state.urls[debtSettlementStatement]);
	const {getLink, isLoading, isError, setIsError} = useGetEndpointUrl(debtSettlementStatement);
	const theme = useTheme();

	const handleClick = () => {
		if (cachedURL) {
			window.open(cachedURL);
			return;
		}

		getLink(makeGetDebtSettlementStatementUrl);
	};

	return (
		<Fragment>
			<CardActionArea disabled={isLoading} onClick={handleClick} sx={{borderRadius: 1}}>
				<Card
					variant="outlined"
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						padding: 2,
						border: 'none',
					}}>
					<Stack
						direction="row"
						gap={1}
						alignItems="center"
						justifyContent="space-between"
						width="100%">
						<Typography variant="body2" sx={{flex: 1}}>
							{debtSettlementStatement}
						</Typography>

						{isLoading ? (
							<Loading size="24px" fullWidth={false} />
						) : (
							<Icon name="ben-export" size="24" color={theme.palette.primary.main} />
						)}
					</Stack>
				</Card>
			</CardActionArea>
			{isError ? (
				<ModalError
					open={isError}
					onClose={() => setIsError(false)}
					headerTitle={title}
					title={subtitle}
					isFullScreen={false}
					maxWidth={420}
					description={description}
					firstButton={{
						title: backAction,
						handleClick: () => setIsError(false),
						variant: 'outlined',
					}}
					secondButton={{
						title: tryAgainBtn,
						handleClick: () => {
							setIsError(false);
							handleClick();
						},
						variant: 'contained',
					}}
				/>
			) : null}
		</Fragment>
	);
}
